'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var errCode = require('err-code');

var pAny = require('p-any');

module.exports = function (node) {
  var routers = node._modules.peerRouting || []; // If we have the dht, make it first

  if (node._dht) {
    routers.unshift(node._dht);
  }

  return {
    /**
     * Iterates over all peer routers in series to find the given peer.
     *
     * @param {String} id The id of the peer to find
     * @param {object} [options]
     * @param {number} [options.timeout] How long the query should run
     * @returns {Promise<PeerInfo>}
     */
    findPeer: function () {
      var _findPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, options) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (routers.length) {
                  _context2.next = 2;
                  break;
                }

                throw errCode(new Error('No peer routers available'), 'NO_ROUTERS_AVAILABLE');

              case 2:
                return _context2.abrupt("return", pAny(routers.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(router) {
                    var result;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return router.findPeer(id, options);

                          case 2:
                            result = _context.sent;

                            if (!(!result || Object.keys(result).length === 0)) {
                              _context.next = 5;
                              break;
                            }

                            throw errCode(new Error('not found'), 'NOT_FOUND');

                          case 5:
                            return _context.abrupt("return", result);

                          case 6:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }())));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function findPeer(_x, _x2) {
        return _findPeer.apply(this, arguments);
      }

      return findPeer;
    }()
  };
};